import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhyFailed } from './components/WhyFailed';
import { MethodSOS } from './components/MethodSOS';
import { ChaptersInside } from './components/ChaptersInside';
import { ToolsIncluded } from './components/ToolsIncluded';
import { Bonus } from './components/Bonus';
import { ForWhom } from './components/ForWhom';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-sage/30 selection:text-forest" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <WhyFailed data-id="element-3" />
      <MethodSOS data-id="element-4" />
      <ChaptersInside data-id="element-5" />
      <ToolsIncluded data-id="element-6" />
      <Bonus data-id="element-7" />
      <ForWhom data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}